import { createFileRoute } from '@tanstack/react-router';
import { AlertsTopic } from '../screens/company/topics/AlertsTopic';

export const Route = createFileRoute('/t/$tenant/settings/billing/alerts')({
  component: AlertsTopic,
});
